import axios from 'axios'
import { Toast } from 'vant'
import errorCode from './errorCode'
import {getLN, getPageCode, getVisitor} from '@/util/auth'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 初始化 headers
    config.headers = config.headers || {}

    // 是否需要设置 token
    const isToken = config.headers.isToken !== false
    const ln = getLN();
    const pageCode = getPageCode()

    if (isToken) {
      if (!ln) {
        return Promise.reject('缺少必要参数');
      }
      const timestamp = Date.now();
      const dataToEncrypt = {
        ln,
        timestamp
      };
      const encryptedToken = encrypt(dataToEncrypt);
      config.headers['X-token'] = 'Bearer ' + encryptedToken
      config.headers['x-visitor'] = getVisitor()
      config.headers['x-page-code'] = pageCode
      config.headers['x-ln'] = ln
    }

    // 移除自定义 headers
    delete config.headers.isToken

    // 添加时间戳防止缓存
    if (config.method === 'get') {
      config.params = {
        ...config.params,
        _t: Date.now()
      }
    }

    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 获取错误码
    const code = response.data.code || 200
    const msg = response.data.message || response.data.msg || errorCode[code] || errorCode['default']

    // 二进制数据直接返回
    if (response.request.responseType === 'blob' || response.request.responseType === 'arraybuffer') {
      return response.data
    }

    // 成功状态码
    if (code === 200 || code === 0) {
      return response.data
    }

    // 特殊错误码处理
    if (code === 401) {
      // 未登录或 token 过期
      Toast.fail('登录状态已过期，请重新登录')
      return Promise.reject(new Error(msg))
    }

    if (code === 500) {
      Toast.fail(msg)
      return Promise.reject(new Error(msg))
    }

    // 其他错误
    Toast.fail(msg)
    return Promise.reject(new Error(msg))
  },
  error => {
    let { message } = error
    if (message === 'Network Error') {
      message = '后端接口连接异常'
    } else if (message.includes('timeout')) {
      message = '系统接口请求超时'
    } else if (message.includes('Request failed with status code')) {
      message = '系统接口' + message.substr(message.length - 3) + '异常'
    }
    Toast.fail(message)
    return Promise.reject(error)
  }
)
function encrypt(data) {
  // 这里是你的加密逻辑
  return btoa(JSON.stringify(data));
}

// 封装请求方法
export default function request(options) {
  return service(options)
}

// GET 请求
export function get(url, params, config = {}) {
  return service({
    url,
    method: 'get',
    params,
    ...config
  })
}

// POST 请求
export function post(url, data, config = {}) {
  return service({
    url,
    method: 'post',
    data,
    ...config
  })
}

// PUT 请求
export function put(url, data, config = {}) {
  return service({
    url,
    method: 'put',
    data,
    ...config
  })
}

// DELETE 请求
export function del(url, params, config = {}) {
  return service({
    url,
    method: 'delete',
    params,
    ...config
  })
}

// 上传文件
export function upload(url, file, config = {}) {
  const formData = new FormData()
  formData.append('file', file)
  return service({
    url,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    ...config
  })
}

// 下载文件
export function download(url, params, filename, config = {}) {
  return service({
    url,
    method: 'get',
    params,
    responseType: 'blob',
    ...config
  }).then(response => {
    const blob = new Blob([response])
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(link.href)
  })
}
